import { resolveWeatherMapWidgetLayout } from '../../../utils/weatherMapWidgetLayout.utils';

export const DOPPLER_RADAR_WIDGET_LAYOUT_CONFIG = Object.freeze({
  '1x1': Object.freeze({ useSinglePanelCompactControls: true }),
  '1x2': Object.freeze({ useSinglePanelCompactControls: true }),
  '2x1': Object.freeze({ useSinglePanelCompactControls: false }),
});

export function getDopplerRadarWidgetLayoutConfig(layout) {
  const resolvedLayout = resolveWeatherMapWidgetLayout({ layout });
  return DOPPLER_RADAR_WIDGET_LAYOUT_CONFIG[resolvedLayout];
}
